<template>
  <v-container>
    <TopBar />

    <v-layout align-center justify-center row fill-height>
      <v-card class="style1">
        <v-img :src="image1" aspect-ratio="4.8"></v-img>

        <v-card-title primary-title v-if="error">Email o contraseña incorrecta, intente nuevamente!</v-card-title>

        <v-card-actions>
          <v-container>
            <v-layout row>
              <v-flex sx8>
                <form>
                  <div class="input-group">
                    <span class="input-group-addon">
                      <i class="glyphicon glyphicon-user"></i>
                    </span>
                    <input
                      id="email"
                      type="text"
                      class="form-control"
                      name="email"
                      v-model="mail"
                      placeholder="Ingrese email"
                    />
                  </div>
                  <div class="input-group">
                    <span class="input-group-addon">
                      <i class="glyphicon glyphicon-lock"></i>
                    </span>
                    <input
                      id="password"
                      type="password"
                      class="form-control"
                      name="password"
                      v-model="password"
                      placeholder="Ingrese su contraseña"
                    />
                  </div>
                </form>
              </v-flex>
            </v-layout>
            <v-layout>
              <a @click="change=true">Recuperar contraseña</a>
            </v-layout>
            <v-layout justify-center>
              <v-btn color="#EB7704" @click="sendResquest" :loading="loading">Entrar</v-btn>
            </v-layout>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-layout>

    <v-dialog v-model="change" width="500">
      <div>
        <v-snackbar
          class="new-alert"
          v-model="alert2"
          :timeout="timeout"
          :color="alertType"
          top="top"
        >
          {{this.alertMessage}}
          <v-icon color="white" flat @click="alert = false">close</v-icon>
        </v-snackbar>
      </div>
      <template v-slot:activator="{ on }"></template>
      <v-card class="new-card">
        <v-card-title>
          <span class="headline">Recuperar contraseña</span>
          <h4>Ingresa tu cuenta de usuario para reestablecer tu contraseña</h4>
        </v-card-title>
        <v-card-actions>
          <v-flex xs11 sm11 md11 lg11 xl11>
            <v-text-field
              :disabled="loading"
              prepend-icon="person"
              name="cuenta"
              label="Cuenta"
              id="cuenta"
              type="mail"
              v-model="mail"
            ></v-text-field>
          </v-flex>
        </v-card-actions>
        <v-card-actions>
          <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>
        </v-card-actions>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#ec6a12" flat="flat" @click="change = false">cancelar</v-btn>
          <v-btn color="#394049" flat="flat" @click="unknowPass()">Enviar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Footer />
  </v-container>
</template>


<script>
import image1 from "../../assets/CABECERA.jpg";
import Footer from "../template/Footer";
import TopBar from "../template/TopBar";
import VueJwtDecode from "vue-jwt-decode";
import jwtDecode from "jwt-decode";

export default {
  components: {
    TopBar,
    Footer
  },
  data() {
    return {
      alert2: false,
      timeout: 4000,
      alertType: "success",
      alertMessage: "",
      change: false,
      image1: image1,
      mail: "",
      password: "",
      loading: false,
      error: false
    };
  },

  mounted() {
    //console.log(process.env.ROOT_API);
  },

  methods: {
    unknowPass() {
      if (this.mail == "") {
        this.showAlert2("error", "Debes completar el formulario");
      } else {
        this.loading = true;
        axios
          .post(
            process.env.ROOT_API + "/user/forgetPassword?correo=" + this.mail
          )
          .then(response => {
            alert(response.data);
            this.$router.push({ name: "unknowPassword" });
            this.mail = "";
          })
          .catch(error => {
            this.showAlert2("error", error.response.data);
            this.loading = false;
          });
      }
    },
    showAlert2(type, message) {
      this.alertType = type;
      this.alertMessage = message;
      this.alert2 = true;
    },
    sendResquest() {
      this.loading = true;
      //console.log(this.mail)
      const config = {
        onDownloadProgress: function(progressEvent) {
          var percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
        }
      };
      const user = {
        username: this.mail,
        pass: this.password
      };

      axios
        .post(process.env.ROOT_API + "/user/login", user)
        .then(response => {
          //console.log(response.status);
          if (response.status == 401) {
            this.error = true;
            this.loading = false;
          } else {
            const payload = {
              codigo: response.data.id,
              email: this.mail,
              loading: true
            };
            //console.log('haciendo la mutación')
            this.$store.commit("CHANGE_USER", payload);
            this.loading = false;
            this.$session.start();
            this.$session.set("jwt", "Bearer " + response.data);
            //console.log(response.data);
            var Decode = jwtDecode(response.data);
            //console.log(Decode);
            this.$session.set("email", Decode.sub);
            this.$session.set("ccData", Decode.ccComplete);
            this.$session.set("userType", Decode.userType);
            this.$session.set("permiso", Decode.permiso);
            this.$session.set("first", Decode.firstTime);
            //console.log(Decode.permiso)
            if (Decode.firstTime == "si") {
              this.$router.push({ name: "changePass" });
            } else if (Decode.userType == "dge") {
              this.$router.push({ name: "ccm" });
            } else {
              this.$router.push({ name: "intro" });
            }
          }
        })
        .catch(error => {
          console.error(error);
          this.error = true;
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
.style1 {
  width: 50%;
}

.v-card__actions .v-btn,
.v-card__actions > * {
  margin-top: 3%;
}

.v-card {
  height: auto;
  overflow-y: auto;
}
h4 {
  font-size: 12px;
}

.new-alert {
  width: 400px;
  margin-top: 80px;
  margin-left: auto;
  margin-right: auto;
  z-index: 10000000000;
}
</style>



// WEBPACK FOOTER //
// src/components/inicio/LoginTest.vue